import { render, staticRenderFns } from "./PoStoryTimeline.vue?vue&type=template&id=06b1e57c"
import script from "./PoStoryTimeline.vue?vue&type=script&lang=js"
export * from "./PoStoryTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports